<template>
  <div class="content">
    <div class="stat">
      <div class="row clearfix">
        <div class="col">
          <div class="card today">
            <img class="bg" src="@/assets/images/icons/member/bg_jrcx.png">
            <div class="info">
              <img class="icon" src="@/assets/images/icons/member/icon_ljcx.png">
              <div class="title">今天消耗积点</div>
              <div class="value">{{stat.today.integral || 0}}</div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card total_query">
            <img class="bg" src="@/assets/images/icons/member/bg_ljcx.png">
            <div class="info">
              <img class="icon" src="@/assets/images/icons/member/icon_ljcxcs.png">
              <div class="title">累计消耗积点</div>
              <div class="value">{{stat.integral || 0}}</div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card total_amount">
            <img class="bg" src="@/assets/images/icons/member/bg_jrcz.png">
            <div class="info">
              <img class="icon" src="@/assets/images/icons/member/icon_jrczcs.png">
              <div class="title">累计充值金额</div>
              <div class="value"><span style="font-size:13px">¥ </span>{{(stat.recharge || 0) | amountThousands}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="records">
      <!-- <a class="rules line2" @click.stop.prevent="isShowRule=true">收费细则</a> -->
      <Tabs value="query">
        <TabPane label="我的查询" name="query">
          <Table :columns="query.columns" :data="query.list" :loading="loaderQuery" no-data-text="暂无记录"></Table>
          <Page :total="query.total" :page-size="pageSize" size="small" @on-change="getQueryList" v-if="query.total > pageSize"></Page>
        </TabPane>
        <TabPane label="积点变动明细" name="integral">
          <Table :columns="integral.columns" :data="integral.list" :loading="loaderIntegral" no-data-text="暂无记录"></Table>
          <Page :total="integral.total" :page-size="pageSize" size="small" @on-change="getIntegralList" v-if="integral.total > pageSize"></Page>
        </TabPane>
      </Tabs>
    </div>
    <ChargesModal :isShowRule="isShowRule" @ruleModalState="isShowRule = $event"></ChargesModal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ChargesModal from './ChargesModal'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default{
  name: 'MyAccountContentZH',
  components: { ChargesModal },
  props: {
    userInfo: {
      type: Object,
      default: () => { return {} },
      required: false
    }
  },
  data () {
    return {
      pageSize: 5,
      loaderQuery: false,
      loaderIntegral: false,
      isShowRule: false,
      query: {
        total: 0,
        columns: [
          {
            title: '功能名称',
            key: 'name',
            align: 'center',
            maxWidth: 320,
            render: (h, params) => {
              return h('div', {
                class: 'func_name'
              }, [
                h('span', params.row.name || '-'),
                params.row.integral === 0 ? h('span', {
                  class: 'free'
                  // attrs: {
                  //   src: require('@/assets/images/icons/member/free.png')
                  // }
                }, '限时免费') : h('span', {
                  class: 'mark'
                // }, this.apiPrice && this.apiPrice(params.row.apiId).integral ? `（${this.apiPrice(params.row.apiId).integral}积点/次）` : '（' + Math.ceil(params.row.integral / params.row.times) + '积点/次）')
                }, '（' + Math.ceil(params.row.integral / params.row.times) + '积点/次）')
              ])
            }
          },
          {
            title: '查询次数',
            key: 'times',
            align: 'center'
          },
          {
            title: '消耗积点',
            key: 'integral',
            align: 'center'
          },
          {
            title: '查询时间',
            key: 'createTime',
            align: 'center',
            className: 'time'
          }
        ],
        list: []
      },
      integral: {
        total: 0,
        columns: [
          {
            title: '类型',
            key: 'type',
            align: 'center',
            render: (h, params) => h('span', this.$options.filters.getIntegralUsedType(params.row.type).name || '-')
          },
          {
            title: '积点',
            key: 'integral',
            align: 'center',
            render: (h, params) => {
              return h('span', {
                class: `integral_value t${params.row.type}`
              }, (params.row.type === 1 ? '-' : '+') + params.row.integral)
            }
          },
          {
            title: '剩余积点',
            key: 'balance',
            align: 'center'
          },
          {
            title: '功能名称',
            key: 'api',
            align: 'center',
            render: (h, params) => h('span', params.row.api || '-')
          },
          {
            title: '时间',
            key: 'createTime',
            align: 'center',
            render: (h, params) => {
              return h('span', this.$options.filters.dataFormat(params.row.createTime, 'dateTime.f1'))
            }
          }
        ],
        list: []
      }
    }
  },
  computed: {
    stat () {
      return this.userInfo.statistics || { today: {} }
    },
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        // return (key) => 0
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.getQueryList()
      this.getIntegralList()
    })
  },
  methods: {
    getQueryList (page = 1) {
      if (this.loaderQuery) return
      this.$Loading.start()
      this._h.scrollTop()
      this.loaderQuery = true
      this.$api.account.member.apiQueryStat({ page: page, size: this.pageSize }, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.query.list = response.data.data.result || []
            this.query.total = response.data.data.count || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.loaderQuery = false
        },
        error: (errorMsg) => {
          this.loaderQuery = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    getIntegralList (page = 1) {
      if (this.loaderIntegral) return
      this.$Loading.start()
      this._h.scrollTop()
      this.loaderIntegral = true
      this.$api.account.member.integral.history({ page: page, size: this.pageSize }, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.integral.list = response.data.data.result || []
            this.integral.total = response.data.data.count || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.loaderIntegral = false
        },
        error: (errorMsg) => {
          this.loaderIntegral = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    ...mapDataGetters(['getApiValue'])
  }
}
</script>
<style scoped>
 @media print,screen and (min-width:1366px) {
  .stat .card, .stat .card .bg{
    width: 220px !important;
  }
  .stat .card .info .title{
    font-size: 15px !important;
  }
  .stat .card .info .value{
    font-size: 18px !important;
  }
}
@media print,screen and (max-width:1365px) {
  .stat .card, .stat .card .bg{
    width: 190px !important;
  }
  .stat .card .info .title{
    font-size: 13px !important;
  }
  .stat .card .info .value{
    font-size: 16px !important;
  }
  .stat .card .info{
    padding-left: 56px !important;
  }
  .stat .card .info .icon{
    left: 15px !important
  }
}
.stat{
  margin: 5px 0 25px;
}
 .stat .row .col{
   float: left;;
   margin-left: 25px;
 }
 .stat .row .col:first-child{
   margin-left: 0;
 }
.stat .card{
  position: relative;
  width: 210px;
}
.stat .card .bg{
  width: 210px;
}
.stat .card .info{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 75px;
}
.stat .card .info .icon{
  position: absolute;
  top: 50%;
  left: 25px;
  transform: translateY(-50%);
  width: 30px;
}
.stat .card .info .title{
  font-size: 14px;
  margin-top: 2px;
}
.stat .card .info .value{
  font-size: 18px;
  padding-left: 1px;
  margin-top: 2px;
}
.records{
  position: relative;
}
.records .rules{
  background: url("~@/assets/images/icons/member/yiwen.png") 0 1px no-repeat transparent;
  background-size: 15px auto;
  font-size: 12px;
  color: #999;
  position: absolute;
  top: 10px;
  right: 5px;
  padding-left: 20px;
  cursor: pointer;
  z-index: 1;
}
.content >>> .ivu-tabs-bar{
  border-bottom: 0 none;
  margin-bottom: 0;
}
.content >>> .ivu-tabs-ink-bar{
  background-color: #1F8AFD;
  height: 1px;
}
.content >>> .ivu-table th{
  background-color: #F9F9F9;
}
.content >>> .ivu-table-wrapper,
.content >>> .ivu-table th,
.content >>> .ivu-table td{
  border-color: #ECECEC;
  font-weight: normal;
  font-size: 13px;
}
.content >>> .ivu-table-wrapper{
  border: 0 none;
}
.content >>> .ivu-table:after{
  width: 0;
}
.content >>> .ivu-table-cell{
  color: #333;
}
.content >>> .ivu-table td.time .ivu-table-cell{
  color: #999;
}
.content >>> .ivu-spin-fix{
  border-color: #E8E8E8;
  background-color: rgba(255, 255, 255, .7);
}
.content >>> .ivu-table-tip{
  color: #999;
}
.content >>> tr.ivu-table-row-hover td{
  /* background-color: #edf8ff; */
}
.content >>> tr .func_name{
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-right: 90px;
  min-height: 25px;
}
.content >>> tr .func_name .free{
  /*padding-left: 5px;*/
  /*width: 48px;*/
  position: relative;
  /* top: -2px; */
  font-size: 10px;
  color: #1F8AFD;
  border: 0.5px solid #1F8AFD;
  padding: 1px 5px;
  margin-left: 10px;
  border-radius: 10px;
  white-space: nowrap;
}
.content >>> tr .func_name .free,
.content >>> tr .func_name .mark{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}
.content >>> tr .func_name .mark{
  font-size: 10px;
  color: #999;
  white-space: nowrap;
}
.content >>> .ivu-page{
  margin: 20px 0;
  text-align: right;
}
.content >>> .ivu-page.mini .ivu-page-item{
  border: 1px solid #EDEDED;
  margin: 0 3px;
}
.content >>> .ivu-page.mini .ivu-page-item a{
  color: #999;
  font-size: 13px;
}
.content >>> .ivu-page-item-active{
  background-color: #1F8AFD;
}
.content >>> .ivu-page.mini .ivu-page-item.ivu-page-item-active a{
  color: #fff;
}
.content >>> .integral_value{
  color: #FE628D;
}
.content >>> .integral_value.t1{
  color: #1ECD7A;
}
.content >>> .ivu-tabs-tab{
  color: #999;
}
.content >>> .ivu-tabs-tab.ivu-tabs-tab-active{
  color: #1F8AFD;
}
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/Content.vue